import { BarLine, BarLinePartitionProps, BarLineSizes, Column, Text, Title } from '@ydistri/ds';
import { shortenNumber } from '@ydistri/generic-utils';
import React, { useMemo } from 'react';
import { styled } from 'styled-components';
import { COLORS } from '@ydistri/theme';

interface CategoryInsightsContributionBarProps {
  value: number;
  percentage: number;
  description: string;
}

const createSummaryBarData = (percentage: number): BarLinePartitionProps[] => {
  // Ensure the percentage is between 0 and 100
  const percentageChecked = Number.isFinite(percentage) ? percentage : 0;
  const validatedPercentage = Math.max(0, Math.min(percentageChecked, 100));

  return [
    {
      percentage: validatedPercentage,
      minSizeToDisplayContent: 16,
      color: 'rgba(243, 152, 25, 1)',
      highlightedPercentage: 0,
    },
    {
      percentage: 100 - validatedPercentage,
      minSizeToDisplayContent: 16,
      color: 'rgba(239,210,203,0.15)',
      highlightedPercentage: 100,
    },
  ];
};

const CategoryInsightsContributionBarWrapper = styled(Column)`
  flex: 1 1 170px;
  min-width: 160px;

  @media (max-width: 1600px) {
    min-width: 120px;
  }

  @media (max-width: 1520px) {
    min-width: 80px;
  }

  @media (max-width: 1500px) {
    min-width: 60px;
  }
`;

const CategoryInsightsContributionBar: React.FC<CategoryInsightsContributionBarProps> = ({
  value,
  percentage,
  description,
}) => {
  const barData = useMemo(() => createSummaryBarData(percentage), [percentage]);

  return (
    <CategoryInsightsContributionBarWrapper
      data-testid={`CategoryInsightsContributionBar-${description.replace(/\s+/g, '')}`}
    >
      <BarLine
        size={BarLineSizes.XSMALL}
        data={barData}
        dividers={false}
        backgroundColor={COLORS.HOVER_GREY_LIGHT}
      />
      <Title $size="xLarge">{shortenNumber(value)}</Title>
      <Text>{description}</Text>
    </CategoryInsightsContributionBarWrapper>
  );
};

export default CategoryInsightsContributionBar;
